import { render, staticRenderFns } from "./DepartmentInsightsTable.vue?vue&type=template&id=14603105&"
import script from "./DepartmentInsightsTable.vue?vue&type=script&lang=js&"
export * from "./DepartmentInsightsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports